import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getUserListRequest, getUserListRequestError, getUserListRequestSuccess } from "../../slices/user-management/GetUsersListSlice";

export const UsersListApi = (page, limit, search, date, status) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        search: search,
        filterStatus: status,
        registeredDate: date
    }).toString();

    const urlWithParams = `${endpoints.usersList}?${queryParams}`;
    try {
        dispatch(getUserListRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUserListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUserListRequestError(_error));
            });
    } catch (error) { }
};
